import { createBrowserRouter } from "react-router";
import { ROUTES } from "./helpers/constants";
import AuthProvider from "./authentication/AuthProvider";
import Login from "./pages/login/Login";
import ProtectedRouteProvider from "./authentication/ProtectedRouteProvider";
import UserList from "./pages/user/UserList";
import AdminList from "./pages/admin/AdminList";
import UserDetail from "./pages/user/UserDetail";

const router = createBrowserRouter([
    {
        path: ROUTES.MAIN,
        Component: AuthProvider,
        children: [{ index: true, Component: Login }, {
            path: ROUTES.MAIN,
            Component: ProtectedRouteProvider,
            children: [{
                path: ROUTES.USER_LIST,
                children: [
                    { index: true, Component: UserList },
                    { path: ":id", Component: UserDetail },
                ],
            }, {
                path: ROUTES.ADMIN_LIST,
                children: [
                    { index: true, Component: AdminList },
                    /* { path: ":id", Component: UserDetail }, */
                ],
            }]
        }]
    },
]);

export default router;